import React from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { cn } from '../../../../../utils/styles';
import Icons from '../../../../../components/Common/Icons/Icons';

export interface CampaignRes {
  id: number;
}

export const campaignCol: ColumnDef<CampaignRes>[] = [
  {
    accessorKey: 'level',
    header: 'Priority Level',
    cell: 'Default',
  },
  {
    accessorKey: 'message',
    header: 'Message area',
    cell: () => (
      <div
        className={cn([
          'uppercase text-[12px] opacity-70 m-[-7px] leading-[19px]',
          'child:p-[10px_20px] first:child:border-b',
        ])}
      >
        <div>text message area</div>
        <div>Image message area</div>
      </div>
    ),
  },
  {
    accessorKey: 'criteria',
    header: 'Criteria',
    cell: () => (
      <div
        className={cn([
          'uppercase text-[12px] m-[-7px] leading-[19px]',
          'child:p-[10px_20px] first:child:border-b child:pr-0',
        ])}
      >
        <div className="flex justify-between gap-2">
          <div className="opacity-70">General Message</div>
          <Icons.PDF className="cursor-pointer text-primary" />
        </div>
        <div className="flex justify-between gap-2">
          <div className="opacity-70">General Message</div>
          <div className="flex gap-2 items-center child:cursor-pointer">
            <Icons.Web className="h-[20px] text-primary" />
            <Icons.PDF className="text-primary" />
          </div>
        </div>
      </div>
    ),
  },
];
